
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Fulfillment() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('https://public.readdy.ai/ai/img_res/2872b8420eb6a4f67f724335c29918b2.jpg')`
        }}
      >
        <div className="text-center text-white">
          <h1 className="text-5xl font-bold mb-4">3PL FULFILLMENT</h1>
          <p className="text-xl">고객과 성장하며 함께 웃는 3PL 전문회사</p>
        </div>
      </section>

      {/* Main Introduction */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              올딩스 3PL fulfillment는
            </h2>
            <p className="text-2xl text-blue-600 font-semibold mb-8">
              고객과 성장하며 함께 웃는 3PL 전문회사입니다
            </p>
            <div className="max-w-4xl mx-auto">
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                국내/해외 물류 대행서비스
              </h3>
              <div className="flex flex-wrap justify-center gap-4 mb-8">
                <span className="bg-blue-100 text-blue-800 px-6 py-3 rounded-full text-lg font-semibold">아마존</span>
                <span className="bg-blue-100 text-blue-800 px-6 py-3 rounded-full text-lg font-semibold">큐텐</span>
                <span className="bg-blue-100 text-blue-800 px-6 py-3 rounded-full text-lg font-semibold">쿠팡</span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Professional%203PL%20fulfillment%20operations%20showing%20Amazon%2C%20Qoo10%2C%20and%20Coupang%20marketplace%20integration%2C%20e-commerce%20logistics%20center%20with%20branded%20packaging%20and%20shipping%20processes%20for%20major%20Korean%20and%20global%20platforms&width=600&height=400&seq=marketplace-fulfillment&orientation=landscape"
                alt="3PL 풀필먼트 서비스"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-900">
                전문 플랫폼 대행 서비스
              </h3>
              <div className="space-y-4 text-lg text-gray-700">
                <p>
                  <strong className="text-blue-600">아마존 FBA 대행</strong><br />
                  글로벌 아마존 마켓플레이스 진출을 위한 전문 물류 서비스
                </p>
                <p>
                  <strong className="text-blue-600">큐텐 물류 대행</strong><br />
                  동남아시아 최대 이커머스 플랫폼 큐텐 전용 물류 솔루션
                </p>
                <p>
                  <strong className="text-blue-600">쿠팡 풀필먼트</strong><br />
                  국내 1위 이커머스 쿠팡의 빠른 배송 요구사항 완벽 대응
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Services */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              핵심 서비스 영역
            </h2>
            <p className="text-xl text-gray-600">
              센터운영, 수/배송, WMS System
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* 센터운영 */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-building-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">센터운영</h3>
              <p className="text-lg font-semibold text-blue-600 mb-4">상품 운영 및 관리</p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                  신속 정확한 운영 관리
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                  유통가공 업무
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                  재고관리 및 책임
                </li>
              </ul>
              <div className="mt-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20warehouse%20center%20operations%20with%20workers%20managing%20inventory%2C%20product%20handling%20and%20processing%20in%20organized%20logistics%20facility%2C%20efficient%20warehouse%20management%20with%20quality%20control%20systems&width=400&height=250&seq=center-operations&orientation=landscape"
                  alt="센터운영"
                  className="w-full h-32 object-cover object-top rounded-lg"
                />
              </div>
            </div>

            {/* 수/배송 */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-truck-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">수/배송</h3>
              <p className="text-lg font-semibold text-blue-600 mb-4">국내배송/해외배송</p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                  판매점 배송관리
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                  백화점 검납 배송관리
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                  아마존 큐텐 배송
                </li>
              </ul>
              <div className="mt-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20delivery%20and%20shipping%20operations%20with%20trucks%20loading%20packages%2C%20domestic%20and%20international%20shipping%20logistics%2C%20efficient%20distribution%20network%20with%20delivery%20vehicles%20and%20cargo%20handling&width=400&height=250&seq=shipping-delivery&orientation=landscape"
                  alt="수/배송"
                  className="w-full h-32 object-cover object-top rounded-lg"
                />
              </div>
            </div>

            {/* WMS System */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-computer-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">WMS System</h3>
              <p className="text-lg font-semibold text-blue-600 mb-4">센터 운영관리 시스템(WMS)</p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                  입/출고 관리
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                  재고관리
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mr-2 mt-1"></i>
                  실시간 모니터링
                </li>
              </ul>
              <div className="mt-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Advanced%20WMS%20warehouse%20management%20system%20with%20computer%20screens%20showing%20inventory%20tracking%2C%20barcode%20scanning%20technology%2C%20and%20real-time%20logistics%20monitoring%20dashboard%20in%20modern%20control%20center&width=400&height=250&seq=wms-system&orientation=landscape"
                  alt="WMS 시스템"
                  className="w-full h-32 object-cover object-top rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Detailed Services */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              상세 서비스 내용
            </h2>
            <p className="text-xl text-gray-600">
              각 영역별 전문 서비스를 제공합니다
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {/* 센터운영 상세 */}
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-900 flex items-center">
                <i className="ri-building-line text-blue-600 mr-3"></i>
                센터운영 서비스
              </h3>
              <div className="bg-blue-50 rounded-lg p-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-4">상품 운영 및 관리</h4>
                <div className="grid grid-cols-1 gap-4">
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3"></div>
                    <div>
                      <p className="font-semibold text-gray-900">신속 정확한 운영 관리</p>
                      <p className="text-gray-600 text-sm">실시간 재고 추적 및 효율적인 상품 관리 시스템</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3"></div>
                    <div>
                      <p className="font-semibold text-gray-900">유통가공 업무</p>
                      <p className="text-gray-600 text-sm">라벨링, 포장, 세트 구성 등 부가가치 서비스</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3"></div>
                    <div>
                      <p className="font-semibold text-gray-900">재고관리 및 책임</p>
                      <p className="text-gray-600 text-sm">정확한 재고 관리와 상품 손실에 대한 책임 보장</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 수/배송 상세 */}
            <div className="space-y-6">
              <h3 className="text-3xl font-bold text-gray-900 flex items-center">
                <i className="ri-truck-line text-blue-600 mr-3"></i>
                수/배송 서비스
              </h3>
              <div className="bg-green-50 rounded-lg p-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-4">국내배송/해외배송</h4>
                <div className="grid grid-cols-1 gap-4">
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3"></div>
                    <div>
                      <p className="font-semibold text-gray-900">판매점 배송관리</p>
                      <p className="text-gray-600 text-sm">온라인 쇼핑몰 및 오프라인 매장 배송 관리</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3"></div>
                    <div>
                      <p className="font-semibold text-gray-900">백화점 검납 배송관리</p>
                      <p className="text-gray-600 text-sm">백화점 입점 상품의 검수 및 납품 배송 서비스</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3"></div>
                    <div>
                      <p className="font-semibold text-gray-900">아마존 큐텐 배송</p>
                      <p className="text-gray-600 text-sm">글로벌 이커머스 플랫폼 전용 배송 서비스</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Flow */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              3PL 풀필먼트 프로세스
            </h2>
            <p className="text-xl text-gray-600">
              체계적인 프로세스로 완벽한 서비스를 제공합니다
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              {
                step: '01',
                title: '상품 입고',
                description: '고객 상품을 안전하게 입고 받아 검수 및 등록',
                icon: 'ri-inbox-line'
              },
              {
                step: '02',
                title: '재고 관리',
                description: 'WMS 시스템을 통한 실시간 재고 관리 및 추적',
                icon: 'ri-database-2-line'
              },
              {
                step: '03',
                title: '주문 처리',
                description: '주문 접수 즉시 피킹, 패킹 작업 진행',
                icon: 'ri-shopping-cart-line'
              },
              {
                step: '04',
                title: '배송 완료',
                description: '신속하고 안전한 배송으로 고객 만족도 극대화',
                icon: 'ri-truck-line'
              }
            ].map((process, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-6">
                  <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${process.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                    <span className="text-sm font-bold text-blue-600">{process.step}</span>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{process.title}</h3>
                <p className="text-gray-600">{process.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
